import {
    Grid } from "../ui";
import React,
    { useEffect,
    useState } from "react";
import EnterButton from "../global/EnterButton";
import CustomDataGrid from "../global/CustomDataGrid";
import { useSelector } from "react-redux";
import SnpButton from "../global/SnpButton";
import {
  getAuthSession,
  isEmpty,
  isRoleAllowed,
  PayMedium,
  printDebugLog,
  SUCCESS,
  ROLE_CREATE,
  ROLE_UPDATE,
  EMPSALARYMGMT
} from "../../constants/constant";
import { useLocation } from "react-router-dom";
import { snpAxios } from "../global/api";
import DialogSalary from "./DialogSalary";
import DismissButton from "../global/DismissButton";
import DialogBox from "../global/DialogBox";
import uiUtilInstance from "../../utilities/uiUtil";

const EmployeeSalary = ({ showSnackbar, setLoader }) => {

    const INITIAL_EMPLOYEE_SALARY = {
        id: "",
        amount: 0.0,
        entryBy: "",
        drCr: "",
        message: "",
        accountType: "",
        refId: "",
        details: "",
        createdAt: "",
        paidOn: "",
        payMedium:PayMedium.ONLINE,
        onlinePayThrough: getAuthSession().onlinePayMethod[0],
        cashPayThrough: "",
        onlinePay: 0.0,
        cashPay: 0.0,
        cgst: 0.0,
        sgst: 0.0,
        sgstAmt: 0.0,
        cgstAmt: 0.0,
        isGstAllowed: false,
    };

    const INITIAL_EMPLOYEE_DETAILS = {
        refId: "",
        details: "",
        totalBal:0.0,
        totalCashBalance:0.0,
        totalOnlineBalance:0.0,
    };

    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const location = useLocation();

    const [employeeDetails, setEmployeeDetails] = useState(INITIAL_EMPLOYEE_DETAILS);
    const [employeeSalary, setEmployeeSalary] = useState(INITIAL_EMPLOYEE_SALARY);
    const [listEmployeeSalary, setListEmployeeSalary] = useState([]);

    // const { dialogs, openDialog, closeDialog } = useMultiDialogController();
    const [showDialog,setShowDialog] = useState(false);

    const fireSnackBarMsg = (msg,mHorizontal = "right", mVertical= "top" , mColor = "#008b8b") => {
        showSnackbar(msg,mColor,mVertical,mHorizontal);
    };

    useEffect(() => {
        printDebugLog("EmployeeSalary useEffect ", storeActiveShopHash);
        printDebugLog("EmployeeSalary useEffect ", storeApiUrl);
        printDebugLog("EmployeeSalary useEffect", location.state?.empId);
        if (!isEmpty(location.state?.empId)) {
            getEmployeeSalary(location.state?.empId);
        }
    }, [storeActiveShopHash, storeApiUrl, location.state]);

    useEffect(()=> {
        printDebugLog("EmployeeSalary employeeDetails ", employeeDetails);
    }, [employeeDetails]);

    useEffect(()=> {
        printDebugLog("EmployeeSalary employeeSalary ", employeeSalary);
    }, [employeeSalary]);

    const getEmployeeSalary = async (empId) => {
        try {
            setLoader(true);
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}accounting/get-employee-salary`;
            const requestData = {
                jcJson: {
                    apiToken: getAuthSession().apiToken,
                    shopHash: storeActiveShopHash.id,
                    empId: empId,
                }
            };
            const response = await snpAxios.post(cUrl, requestData);
            printDebugLog(`getEmployeeSalary:${empId}`, response.data);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.jcJson;
                setEmployeeDetails(prev => ({
                    ...prev,
                    refId: payLoad.refId,
                    details: payLoad.details,
                    totalBal:payLoad.totalBal,
                    totalCashBalance:payLoad.totalCashBalance,
                    totalOnlineBalance:payLoad.totalOnlineBalance,
                }));
                setListEmployeeSalary(payLoad.fullData);
            }
            setLoader(false);
        } catch (error) {
            console.error(`getEmployeeSalary:${empId}`, error);
            setLoader(false);
        }
    };

    const handleEmployeeSalarySubmit = async() => {
        try {
            setLoader(true);
            const cUrl = `${storeApiUrl.BACKEND_BASE_URL}accounting/set-employee-salary`;
            const requestData = {
                jcJson: {
                    apiToken: getAuthSession().apiToken,
                    shopHash: storeActiveShopHash.id,
                    empId: employeeDetails.refId,
                    message:employeeSalary.message,
                    amount:employeeSalary.amount,
                    paidOn:employeeSalary.paidOn,
                    id:employeeSalary.id,
                    payMedium:employeeSalary.payMedium,
                    onlinePayMedium:employeeSalary.onlinePayThrough,
                    onlinePay:employeeSalary.onlinePay,
                    cashPay:employeeSalary.cashPay,
                }
            };
            const response = await snpAxios.post(cUrl, requestData);
            handleDialogClose();
            printDebugLog(`handleEmployeeSalarySubmit`, response.data);
            if (response.data.status === SUCCESS) {
                getEmployeeSalary(employeeDetails.refId);
            }
            setLoader(false);
        } catch (error) {
            console.error(`handleEmployeeSalarySubmit`, error);
            setLoader(false);
        }
    };

    const columns = [
        {
            field: 'details', headerName: 'Paid To', width: 200, renderCell: (params) => (
                <span style={{
                    fontWeight:"bold",
                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word'
                }}>{params.value}</span>
            ),
        },
        { field: 'paidOn', headerName: 'Paid On', width: 150 },
        { field: 'entryBy', headerName: 'Entry By', width: 150 },
        { field: 'amount', headerName: 'Amount', width: 150 },
        {
            field: 'via', headerName: 'Pay via', width: 200, renderCell: (params) => (
                <span style={{
                     color: '#151b45',
                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word'
                }}>{params.value}</span>
            ),
        },
        {
            field: "edit",
            headerName: "",
            width: 120,
            renderCell: (cellValues) => {
                return (
                    isRoleAllowed(EMPSALARYMGMT, ROLE_UPDATE) &&
                    <SnpButton variant="contained"
                        mbgcolor="#538796"
                        mpadding="2px 8px"
                        onClick={() => {
                            handleViewClick(cellValues);
                        }}
                    >Edit</SnpButton>
                );
            }
        },
    ];

    const handleViewClick = (cellValues) => {
        setShowDialog(true);
        setEmployeeSalary(prev => ({
            ...prev, ...cellValues.row,
        }))
    };

    const handleDialogClose = () => {
        setShowDialog(false);
        setEmployeeSalary(INITIAL_EMPLOYEE_SALARY);
    }

    const renderDialogContent = () => {
        return (
            <DialogSalary
                fireSnackBarMsg={fireSnackBarMsg}
                employeeDetails={employeeDetails}
                employeeSalary={employeeSalary}
                setEmployeeSalary={setEmployeeSalary} />
        )
    };

    const renderDialogAction = () => {
        return (
            <>
                <SnpButton variant="contained" onClick={handleEmployeeSalarySubmit}>
                    Submit
                </SnpButton>

                <DismissButton variant="contained" onClick={handleDialogClose}>
                    Dismiss
                </DismissButton>
            </>
        )
    }

    // const handleDialogAdd = () => {
    //     openDialog("addDialog", {
    //         title: "Salary Component",
    //         dialogContent: () => (
    //             <DialogSalary
    //                 employeeDetails={employeeDetails}
    //                 employeeSalary={employeeSalary}
    //                 setEmployeeSalary={setEmployeeSalary} />
    //         ),
    //         dialogActions: (
    //             <>

    //                 <SnpButton variant="contained" onClick={handleEmployeeSalarySubmit}>
    //                     Submit
    //                 </SnpButton>

    //                 <DismissButton variant="contained" onClick={handleDialogClose}>
    //                     Dismiss
    //                 </DismissButton>
    //             </>
    //         ),
    //     });
    // };



    return (
        <Grid container spacing={1}>
            <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ padding: 10 }}>
                    <EnterButton
                        variant="contained"
                        color="primary"
                        sx={{ boxShadow: 10 }}
                        style={{ float: "right" }}
                        onClick={()=> {
                            if (isRoleAllowed(EMPSALARYMGMT, ROLE_CREATE)) {
                                setEmployeeSalary(prev => ({
                                    ...prev,
                                    createdAt: uiUtilInstance.todayFormattedDate,
                                    paidOn: uiUtilInstance.todayFormattedDate,
                                }));
                                setShowDialog(true);
                            } else {

                            }
                        }}>
                        Update Salary
                    </EnterButton>
                </div>

                <CustomDataGrid
                    getRowId={row => row.id}
                    rows={listEmployeeSalary}
                    columns={columns}
                />
                {/* <DialogBox
                    showDialog={dialogs.addDialog?.show || false}
                    title={dialogs.addDialog?.title}
                    dialogContent={dialogs.addDialog?.dialogContent}
                    dialogActions={dialogs.addDialog?.dialogActions}
                    onClose={() => closeDialog("addDialog")}
                /> */}
                <DialogBox
                    showDialog={showDialog}
                    title="Salary Component"
                    onClose={handleDialogClose}
                    dialogContent={renderDialogContent()}
                    dialogActions={renderDialogAction()}
                />
            </Grid>
        </Grid>
    )
}
export default EmployeeSalary;